import styled from "styled-components";

export const LoadingContainer = styled.div`
  background-color: #fff;
  min-height: 100vh;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  z-index: 100;
`;

export const LoadingLogo = styled.img`
  width: 15%;
  min-width: 250px;
  animation: fadeIn 2s infinite alternate;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
  }
`;
